export default "__VITE_ASSET__CvRifjQM__"